import { Link } from 'react-router'

import MenuFoldOutlinedIcon from '@ant-design/icons/MenuFoldOutlined'
import MenuUnfoldOutlinedIcon from '@ant-design/icons/MenuUnfoldOutlined'

import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import IconButton from '@mui/material/IconButton'
import { useTheme } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'

import { RoleGuard } from '@shared/providers/src/MeProvider'
import { UserRole } from '@shared/utils'

import { useLayoutState } from '@providers/LayoutStateProvider'
import { resolveLogo } from '@utils/Helper'

import PharmacySelector from './PharmacySelector'

export default function SidebarHeader() {
  const theme = useTheme()
  const { sidebarOpen, sidebarCollapsed, setSidebarOpen, setSidebarClosed } = useLayoutState()

  const handleToggle = sidebarOpen ? setSidebarClosed : setSidebarOpen
  const ToggleIcon = sidebarCollapsed ? MenuUnfoldOutlinedIcon : MenuFoldOutlinedIcon

  return (
    <Box>
      <Toolbar sx={sidebarCollapsed ? { justifyContent: 'center', px: 1 } : { pl: `${theme.spacing(1)} !important` }}>
        {!sidebarCollapsed && (
          <>
            <ButtonBase disableRipple component={Link} to="/app" sx={{ height: 40 }}>
              <Box component="img" src={resolveLogo(theme.palette.mode)} alt="logo" sx={{ height: '100%', width: 'auto' }} />
            </ButtonBase>
            <Box sx={{ flex: 1 }} />
          </>
        )}
        <IconButton size="small" onClick={handleToggle} sx={{ color: 'text.secondary' }}>
          <ToggleIcon style={{ fontSize: '1rem' }} />
        </IconButton>
      </Toolbar>
      {!sidebarCollapsed && (
        <RoleGuard allowed={[UserRole.Pharmacy, UserRole.PharmacyManager]}>
          <PharmacySelector />
        </RoleGuard>
      )}
    </Box>
  )
}
